module.exports = __webpack_public_path__ + "/images/cover-pareja-pensativa-800.c7d7037.jpg";